import { CountryCodes } from './CountryCodes'
import { CurrencyCodes } from './CurrencyCodes'

export const COUNTRY_CURRENCY: Record<CountryCodes, CurrencyCodes> = {
  AD: 'EUR',
  AE: 'USD',
  AF: 'USD',
  AG: 'USD',
  AI: 'USD',
  AL: 'EUR',
  AM: 'USD',
  AO: 'USD',
  AR: 'USD',
  AS: 'USD',
  AT: 'EUR',
  AU: 'USD',
  AW: 'USD',
  AX: 'EUR',
  AZ: 'USD',
  BA: 'EUR',
  BB: 'USD',
  BD: 'USD',
  BE: 'EUR',
  BF: 'USD',
  BG: 'EUR',
  BH: 'USD',
  BI: 'USD',
  BJ: 'USD',
  BL: 'USD',
  BM: 'USD',
  BN: 'USD',
  BO: 'USD',
  BQ: 'USD',
  BR: 'USD',
  BS: 'USD',
  BT: 'USD',
  BV: 'USD',
  BW: 'USD',
  BY: 'EUR',
  BZ: 'USD',
  CA: 'USD',
  CC: 'USD',
  CD: 'USD',
  CF: 'USD',
  CG: 'USD',
  CH: 'EUR',
  CI: 'USD',
  CK: 'USD',
  CL: 'USD',
  CM: 'USD',
  CN: 'USD',
  CO: 'USD',
  CR: 'USD',
  CU: 'USD',
  CV: 'USD',
  CW: 'USD',
  CX: 'USD',
  CY: 'EUR',
  CZ: 'EUR',
  DE: 'EUR',
  DJ: 'USD',
  DK: 'EUR',
  DM: 'USD',
  DO: 'USD',
  DZ: 'USD',
  EC: 'USD',
  EE: 'EUR',
  EG: 'USD',
  EH: 'USD',
  ER: 'USD',
  ES: 'EUR',
  ET: 'USD',
  FI: 'EUR',
  FJ: 'USD',
  FK: 'GBP',
  FM: 'USD',
  FO: 'EUR',
  FR: 'EUR',
  GA: 'USD',
  GB: 'GBP',
  GD: 'USD',
  GE: 'USD',
  GF: 'USD',
  GG: 'GBP',
  GH: 'USD',
  GI: 'GBP',
  GL: 'USD',
  GM: 'USD',
  GN: 'USD',
  GP: 'USD',
  GQ: 'USD',
  GR: 'EUR',
  GS: 'USD',
  GT: 'USD',
  GU: 'USD',
  GW: 'USD',
  GY: 'USD',
  HK: 'USD',
  HM: 'USD',
  HN: 'USD',
  HR: 'EUR',
  HT: 'USD',
  HU: 'EUR',
  ID: 'USD',
  IE: 'EUR',
  IL: 'USD',
  IM: 'GBP',
  IN: 'USD',
  IO: 'USD',
  IQ: 'USD',
  IR: 'USD',
  IS: 'EUR',
  IT: 'EUR',
  JE: 'GBP',
  JM: 'USD',
  JO: 'USD',
  JP: 'USD',
  KE: 'USD',
  KG: 'USD',
  KH: 'USD',
  KI: 'USD',
  KM: 'USD',
  KN: 'USD',
  KP: 'USD',
  KR: 'USD',
  KW: 'USD',
  KY: 'USD',
  KZ: 'USD',
  LA: 'USD',
  LB: 'USD',
  LC: 'USD',
  LI: 'EUR',
  LK: 'USD',
  LR: 'USD',
  LS: 'USD',
  LT: 'EUR',
  LU: 'EUR',
  LV: 'EUR',
  LY: 'USD',
  MA: 'USD',
  MC: 'EUR',
  MD: 'USD',
  ME: 'EUR',
  MF: 'USD',
  MG: 'USD',
  MH: 'USD',
  MK: 'EUR',
  ML: 'USD',
  MM: 'USD',
  MN: 'USD',
  MO: 'USD',
  MP: 'USD',
  MQ: 'USD',
  MR: 'USD',
  MS: 'USD',
  MT: 'EUR',
  MU: 'USD',
  MV: 'USD',
  MW: 'USD',
  MX: 'USD',
  MY: 'USD',
  MZ: 'USD',
  NA: 'USD',
  NC: 'USD',
  NE: 'USD',
  NF: 'USD',
  NG: 'USD',
  NI: 'USD',
  NL: 'EUR',
  NN: 'GBP',
  NO: 'EUR',
  NP: 'USD',
  NR: 'USD',
  NU: 'USD',
  NZ: 'USD',
  OM: 'USD',
  PA: 'USD',
  PE: 'USD',
  PF: 'USD',
  PG: 'USD',
  PH: 'USD',
  PK: 'USD',
  PL: 'EUR',
  PM: 'USD',
  PN: 'USD',
  PR: 'USD',
  PS: 'USD',
  PT: 'EUR',
  PW: 'USD',
  PY: 'USD',
  QA: 'USD',
  RE: 'USD',
  RO: 'EUR',
  RS: 'EUR',
  RU: 'USD',
  RW: 'USD',
  SA: 'USD',
  SB: 'USD',
  SC: 'USD',
  SD: 'USD',
  SE: 'EUR',
  SG: 'USD',
  SH: 'GBP',
  SI: 'EUR',
  SJ: 'USD',
  SK: 'EUR',
  SL: 'USD',
  SM: 'EUR',
  SN: 'USD',
  SO: 'USD',
  SR: 'USD',
  SS: 'USD',
  ST: 'USD',
  SV: 'USD',
  SX: 'USD',
  SY: 'USD',
  SZ: 'USD',
  TC: 'USD',
  TD: 'USD',
  TF: 'USD',
  TG: 'USD',
  TH: 'USD',
  TJ: 'USD',
  TK: 'USD',
  TL: 'USD',
  TM: 'USD',
  TN: 'USD',
  TO: 'USD',
  TR: 'USD',
  TT: 'USD',
  TV: 'USD',
  TW: 'USD',
  TZ: 'USD',
  UA: 'EUR',
  UG: 'USD',
  UM: 'USD',
  US: 'USD',
  UY: 'USD',
  UZ: 'USD',
  VA: 'EUR',
  VC: 'USD',
  VE: 'USD',
  VG: 'USD',
  VI: 'USD',
  VN: 'USD',
  VU: 'USD',
  WF: 'USD',
  WS: 'USD',
  XK: 'EUR',
  XX: 'GBP', // default to GBP - temp solution to go live TODO: fix account data for BA
  YE: 'USD',
  YT: 'USD',
  ZA: 'USD',
  ZM: 'USD',
  ZW: 'USD',
}
